<template>
  <div id="releaseNotesPage">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="modern-page-header">
            <div class="modern-page-header__left">
              <div class="modern-page-header__icon-wrap">
                <v-icon class="modern-page-header__icon">history</v-icon>
              </div>
              <div>
                <h3 class="modern-page-header__title">Release Notes</h3>
                <p class="modern-page-header__sub">Static commit history with date, time and message</p>
              </div>
            </div>
          </div>
        </v-flex>

        <v-flex xs12>
          <v-card class="modern-table-card">
            <div class="modern-table-toolbar">
              <div class="modern-search-wrap">
                <v-icon class="modern-search-icon">search</v-icon>
                <input
                  v-model="search"
                  class="modern-search-input"
                  placeholder="Search release notes..."
                />
              </div>
            </div>

            <v-card-text class="pa-0">
              <v-data-table
                :headers="headers"
                :items="filteredItems"
                :rows-per-page-items="[10, 25, 50, { text: 'All', value: -1 }]"
                class="modern-data-table"
                item-key="hash"
              >
                <template slot="items" slot-scope="props">
                  <td class="table-cell-date">{{ props.item.date }}</td>
                  <td class="table-cell-date">{{ props.item.time }}</td>
                  <td class="table-cell-mono">{{ props.item.shortHash }}</td>
                  <td class="table-cell-primary">{{ props.item.message }}</td>
                </template>

                <template slot="no-data">
                  <div class="modern-empty-state">
                    <v-icon class="modern-empty-state__icon">history</v-icon>
                    <p class="modern-empty-state__text">No release notes found</p>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import releaseNotes from "@/data/releaseNotes.json";

export default {
  data() {
    return {
      search: "",
      headers: [
        { text: "Date", value: "date", sortable: false },
        { text: "Time", value: "time", sortable: false },
        { text: "Commit", value: "shortHash", sortable: false },
        { text: "Message", value: "message", sortable: false }
      ],
      items: Array.isArray(releaseNotes) ? releaseNotes : []
    };
  },
  computed: {
    filteredItems() {
      const query = this.search.trim().toLowerCase();
      if (!query) return this.items;

      return this.items.filter(item => {
        return [item.date, item.time, item.shortHash, item.message]
          .join(" ")
          .toLowerCase()
          .includes(query);
      });
    }
  }
};
</script>

<style scoped lang="css">
.modern-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0 20px;
  gap: 16px;
}

.modern-page-header__left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.modern-page-header__icon-wrap {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: linear-gradient(135deg, #1565c0, #0d47a1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modern-page-header__icon {
  color: #ffffff !important;
  font-size: 22px !important;
}

.modern-page-header__title {
  font-family: "Inter", "Roboto", sans-serif;
  font-size: 1.3rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  letter-spacing: -0.3px;
}

.modern-page-header__sub {
  font-family: "Inter", "Roboto", sans-serif;
  font-size: 13px;
  color: #64748b;
  margin: 2px 0 0;
}

.modern-table-card {
  border-radius: 14px !important;
  overflow: hidden;
}

.modern-table-toolbar {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  gap: 8px;
}

.modern-search-wrap {
  flex: 1;
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px 14px;
  gap: 10px;
}

.modern-search-icon {
  color: #94a3b8 !important;
  font-size: 18px !important;
}

.modern-search-input {
  border: none;
  outline: none;
  background: transparent;
  font-family: "Inter", "Roboto", sans-serif;
  font-size: 14px;
  color: #334155;
  width: 100%;
}

.modern-search-input::placeholder {
  color: #94a3b8;
}

.table-cell-date {
  color: #475569;
  font-family: "Inter", "Roboto", sans-serif;
  font-size: 13px !important;
}

.table-cell-mono {
  font-family: "SF Mono", "Roboto Mono", monospace;
  font-size: 12px !important;
  color: #64748b !important;
}

.table-cell-primary {
  color: #1e293b;
  font-family: "Inter", "Roboto", sans-serif;
  font-size: 13px !important;
}

.modern-empty-state {
  text-align: center;
  padding: 36px 20px;
  color: #64748b;
}

.modern-empty-state__icon {
  font-size: 32px !important;
  color: #94a3b8 !important;
  margin-bottom: 8px;
}

.modern-empty-state__text {
  margin: 0;
}
</style>
